// export const emojiUrl = 'http://weixin16.bydauto.com.cn/emoji/'
export const emojiUrl = "https://cscccache.byd.com/emoji/";
export const emojiMap = {
    "[微笑]": "weixiao.png",
    "[撇嘴]": "pizui.png",
    "[色]": "2.png",
    "[吓]": "xia.png",
    "[得意]": "4.png",
    "[流泪]": "liulei.png",
    "[害羞]": "haixiu.png",
    "[闭嘴]": "bizui.png",
    "[睡]": "shuijiao.png",
    "[大哭]": "9.png",
    "[尴尬]": "gangga.png",
    "[发怒]": "danu.png",
    "[调皮]": "tiaopi.png",
    "[呲牙]": "ciya.png",
    "[惊讶]": "jingya.png",
    "[难过]": "nanguo.png",
    "[囧]": "jiong.png",
    "[抓狂]": "zhuakuang.png",
    "[吐]": "tu.png",
    "[偷笑]": "touxiao.png",
    "[可爱]": "keai.png",
    "[白眼]": "22.png",
    "[傲慢]": "23.png",
    "[困]": "kun.png",
    "[惊恐]": "jingkong.png",
    "[流汗]": "liuhan.png",
    "[憨笑]": "28.png",
    "[大兵]": "29.png",
    "[奋斗]": "fendou.png",
    "[咒骂]": "zhouma.png",
    "[疑问]": "yiwen.png",
    "[嘘]": "xu.png",
    "[晕]": "yun.png",
    "[衰]": "shuai.png",
    "[骷髅]": "kulou.png",
    "[敲打]": "qiaoda.png",
    "[拜拜]": "zaijian.png",
    "[擦汗]": "cahan.png",
    "[抠鼻]": "koubi.png",
    "[鼓掌]": "guzhang.png",
    "[坏笑]": "huaixiao.png",
    "[右哼哼]": "youhengheng.png",
    "[哈欠]": "haqian.png",
    "[鄙视]": "bishi.png",
    "[委屈]": "weiqu.png",
    "[快哭了]": "kuaikule.png",
    "[阴险]": "yinxian.png",
    "[亲亲]": "qinqin.png",
    "[可怜]": "kelian.png",
    "[菜刀]": "caidao.png",
    "[啤酒]": "pijiu.png",
    "[咖啡]": "kafei.png",
    "[猪头]": "zhutou.png",
    "[玫瑰]": "hua.png",
    "[凋谢]": "diaoxie.png",
    "[吻]": "kiss.png",
    "[爱心]": "aixin.png",
    "[心碎]": "xinsui.png",
    "[蛋糕]": "dangao.png",
    "[炸弹]": "zhadan.png",
    "[大便]": "dabian.png",
    "[月亮]": "yueliang.png",
    "[太阳]": "taiyang.png",
    "[拥抱]": "yongbao.png",
    "[强]": "qiang.png",
    "[弱]": "ruo.png",
    "[握手]": "woshou.png",
    "[胜利]": "shengli.png",
    "[抱拳]": "baoquan.png",
    "[勾引]": "gouyin.png",
    "[拳头]": "quantou.png",
    "[OK]": "ok.png",
    "[跳]": "tiao.png",
    "[发抖]": "fadou.png",
    "[转圈]": "zhuanquan.png",
    "[大笑]": "grinning-face-with-smiling-eyes.png",
    "[生病]": "face-with-medical-mask.png",
    "[破涕为笑]": "lol.png",
    "[哭笑不得]": "diy.png",
    "[懵懂]": "flushed-face.png",
    "[失望]": "letdown.png",
    "[无语]": "duh.png",
    "[嘿哈]": "heiha.png",
    "[捂脸]": "wulian.png",
    "[奸笑]": "jianxiao.png",
    "[机智]": "jizhi.png",
    "[皱眉]": "zhoumei.png",
    "[耶]": "ye.png",
    "[鬼]": "ghost.png",
    "[保佑]": "person-with-folded-hands.png",
    "[强壮]": "flexed-biceps.png",
    "[庆祝]": "party.png",
    "[礼物]": "gift.png",
    "[红包]": "hongbao.png",
    "[發]": "rich.png",
    "[福]": "fu.png",
    "[翻白眼]": "boring.png",
    "[666]": "awesome.png",
    "[让我看看]": "letmesee.png",
    "[叹气]": "sigh.png",
    "[苦涩]": "hurt.png",
    "[裂开]": "broken.png",
    "[恐惧]": "face-screaming-in-fear.png",
    "[笑脸]": "happy.png",
    "[脸红]": "flushed.png",
    "[吃瓜]": "onlooker.png",
    "[加油]": "goforIt.png",
    "[汗]": "sweats.png",
    "[天啊]": "omg.png",
    "[Emm]": "emm.png",
    "[社会社会]": "respect.png",
    "[旺柴]": "doge.png",
    "[好的]": "noprob.png",
    "[打脸]": "mybad.png",
    "[哇]": "wow.png",
    "[烟花]": "fireworks.png",
    "[爆竹]": "baozhu.png",
    "[合十]": "worship.png",
    "[生病]": "sick.png",
};

export const emojiName = [
    "[微笑]",
    "[撇嘴]",
    "[色]",
    "[吓]",
    "[得意]",
    "[流泪]",
    "[害羞]",
    "[闭嘴]",
    "[睡]",
    "[大哭]",
    "[尴尬]",
    "[发怒]",
    "[调皮]",
    "[呲牙]",
    "[惊讶]",
    "[难过]",
    "[囧]",
    "[抓狂]",
    "[吐]",
    "[偷笑]",
    "[可爱]",
    "[白眼]",
    "[傲慢]",
    "[困]",
    "[惊恐]",
    "[流汗]",
    "[憨笑]",
    "[大兵]",
    "[奋斗]",
    "[咒骂]",
    "[疑问]",
    "[嘘]",
    "[晕]",
    "[衰]",
    "[骷髅]",
    "[敲打]",
    "[拜拜]",
    "[擦汗]",
    "[抠鼻]",
    "[鼓掌]",
    "[坏笑]",
    "[右哼哼]",
    "[哈欠]",
    "[鄙视]",
    "[委屈]",
    "[快哭了]",
    "[阴险]",
    "[亲亲]",
    "[可怜]",
    "[菜刀]",
    "[啤酒]",
    "[咖啡]",
    "[猪头]",
    "[玫瑰]",
    "[凋谢]",
    "[吻]",
    "[爱心]",
    "[心碎]",
    "[蛋糕]",
    "[炸弹]",
    "[大便]",
    "[月亮]",
    "[太阳]",
    "[拥抱]",
    "[强]",
    "[弱]",
    "[握手]",
    "[胜利]",
    "[抱拳]",
    "[勾引]",
    "[拳头]",
    "[OK]",
    "[跳]",
    "[发抖]",
    "[转圈]",
    "[大笑]",
    "[生病]",
    "[破涕为笑]",
    "[哭笑不得]",
    "[懵懂]",
    "[失望]",
    "[无语]",
    "[嘿哈]",
    "[捂脸]",
    "[奸笑]",
    "[机智]",
    "[皱眉]",
    "[耶]",
    "[鬼]",
    "[保佑]",
    "[强壮]",
    "[庆祝]",
    "[礼物]",
    "[红包]",
    "[發]",
    "[福]",
    "[生病]",
    "[翻白眼]",
    "[666]",
    "[让我看看]",
    "[叹气]",
    "[苦涩]",
    "[裂开]",
    "[恐惧]",
    "[笑脸]",
    "[脸红]",
    "[吃瓜]",
    "[加油]",
    "[汗]",
    "[天啊]",
    "[Emm]",
    "[社会社会]",
    "[旺柴]",
    "[好的]",
    "[打脸]",
    "[哇]",
    "[烟花]",
    "[爆竹]",
    "[合十]",
];
